var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScientificIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "800px",
    height: "800px",
    viewBox: "0 -0.13 16.264 16.264",
    id: "lab-16px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M-8.121,13.668-13,6.349V1h1.5A.5.5,0,0,0-11,.5a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,0-.5.5.5.5,0,0,0,.5.5H-19V6.349l-4.879,7.319a1.5,1.5,0,0,0-.075,1.54A1.5,1.5,0,0,0-22.631,16H-9.369a1.5,1.5,0,0,0,1.323-.792A1.5,1.5,0,0,0-8.121,13.668ZM-14,1V6.5a.5.5,0,0,0,.084.277L-13.1,8h-5.8l.815-1.223A.5.5,0,0,0-18,6.5V1Zm5.072,13.736A.489.489,0,0,1-9.369,15H-22.631a.489.489,0,0,1-.441-.264.488.488,0,0,1,.025-.513l3.489-5.235A.373.373,0,0,0-19.5,9h7a.373.373,0,0,0,.058-.012l3.489,5.235A.488.488,0,0,1-8.928,14.736ZM-14,10a2,2,0,0,0-2,2,2,2,0,0,0,2,2,2,2,0,0,0,2-2A2,2,0,0,0-14,10Zm0,3a1,1,0,0,1-1-1,1,1,0,0,1,1-1,1,1,0,0,1,1,1A1,1,0,0,1-14,13Zm-3-1.5a.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5A.5.5,0,0,1-17,11.5ZM-19,13a1,1,0,0,1-1,1,1,1,0,0,1-1-1,1,1,0,0,1,1-1A1,1,0,0,1-19,13Z",
    transform: "translate(24.132)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientificIcon);
export default __webpack_public_path__ + "static/media/ScientificIcon.b84dd918c499fd735b553cdd572b3546.svg";
export { ForwardRef as ReactComponent };